import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import { AuthGuard } from '../../login/auth/auth.guard'
import { AuthGuardTwo } from '../../login/auth/auth.guard.two'

import { LayoutComponent } from './layout.component'

const layoutRoutes: Routes = [
  {
    path: 'main',
    canActivate: [AuthGuard],
    component: LayoutComponent,
    children: [
      {
        path: 'general',
        // canActivate:[AuthGuardTwo],
        loadChildren: async () => (await import('../../content/general/general.module')).GeneralModule,
      },
      {
        path: 'organizations',
        canActivate: [AuthGuardTwo],
        loadChildren: async () => (await import('../../content/organizations/organizations.module')).OrganizationsModule,
      },
      {
        path: 'hotels',
        canActivate: [AuthGuardTwo],
        loadChildren: async () => (await import('../../content/hotels/hotels.module')).HotelsModule,
      },
      {
        path: 'support',
        canActivate: [AuthGuardTwo],
        loadChildren: async () => (await import('../../content/support/support.module')).SupportModule,
      },
      {
        path: 'profile',
        canActivate: [AuthGuardTwo],
        loadChildren: async () => (await import('../../content/profile/profile.module')).ProfileModule,
      },
      {
        path: 'bookings',
        canActivate: [AuthGuardTwo],
        loadChildren: async () => (await import('../../content/bookings/bookings.module')).BookingsModule,
      },
      {
        path: 'payment',
        canActivate: [AuthGuardTwo],
        loadChildren: async () => (await import('../../content/payment/payment.module')).PaymentModule,
      },
      {
        path: 'guest-profile',
        canActivate: [AuthGuardTwo],
        loadChildren: async () => (await import('../../content/guest-profile-overview/guest-profile-overview.module')).GuestProfileOverviewModule,
      },
      {
        path: 'automation',
        canActivate: [AuthGuardTwo],
        loadChildren: async () => (await import('../../content/automation/automation.module')).AutomationModule,
      },
    ],
  },
]

@NgModule({
  imports: [RouterModule.forChild(layoutRoutes)],
  exports: [RouterModule],
})
export class LayoutRoutingModule {}
